var ExcelApi = /** @class */ (function () {
    function ExcelApi() {
        this.resolveExcelIndex = function (columnIndex) {
            var tmp, columnIndexAlphaVal = '';
            while (columnIndex > 0) {
                tmp = (columnIndex - 1) % 26;
                columnIndexAlphaVal = String.fromCharCode(tmp + 65) + columnIndexAlphaVal;
                columnIndex = (columnIndex - tmp - 1) / 26;
            }
            return columnIndexAlphaVal;
        };
    }
    Object.defineProperty(ExcelApi.prototype, "excel", {
        get: function () {
            return window.Excel;
        },
        enumerable: false,
        configurable: true
    });
    ExcelApi.prototype.createTable = function (tableDescription, items) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.excel.run(function (context) {
                var currentWorksheet = context.workbook.worksheets.getActiveWorksheet();
                var headersArray = Array.from(tableDescription.keys());
                var excelColumnIndex = _this.resolveExcelIndex(headersArray.length);
                var expensesTable = currentWorksheet.tables.add("A1:" + excelColumnIndex + "1", true /*hasHeaders*/);
                expensesTable.name = "ExpensesTable";
                expensesTable.getHeaderRowRange().values = [headersArray];
                var columnGetters = Array.from(tableDescription.values());
                var rows = items.map(function (item) {
                    var columns = columnGetters.map(function (x) { return x(item); });
                    return columns;
                });
                //This is a function which generates dummy data
                var addRows = function () {
                    var begin = new Date();
                    expensesTable.rows.add(null /*add at the end*/, rows);
                    expensesTable.context.sync().then(function () {
                        var end = new Date();
                        var duration = end - begin;
                        console.log('Import duration', duration);
                        resolve();
                    })
                        .catch(reject);
                };
                addRows();
                expensesTable.getRange().format.autofitColumns();
                expensesTable.getRange().format.autofitRows();
                return context.sync();
            }).catch(function (error) {
                console.log("Error: " + error);
                if (error) {
                    console.log("Debug info: " + JSON.stringify(error.debugInfo));
                }
                reject(error);
            });
        });
    };
    return ExcelApi;
}());
export default new ExcelApi();
//# sourceMappingURL=ExcelApi.js.map